import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "$2529 April sidehustle report",
  "description": "",
  "published": "2017-05-03T00:00:00.000Z",
  "redirect_from": ["/blog/april-sidehustle-report/swizec/7572"],
  "categories": "Business, Side Projects, sidehustle",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/march-2017-sidehustle-report/swizec/7540"
      }}>{`As I predicted last month`}</a>{`, April was a down month. It was the lowest earning month of the year so far, but it wasn’t quite as bad as I expected.`}</p>
    <p>{`I took 2 weeks off the sidehustle. I did nothing but enjoy Europe and make `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=hL3pGjTlvio&list=PLF8WgaD4xmjUn5WldUkcy6YH1vLt7zbAx"
      }}>{`a daily vlog`}</a>{`. There was next-to-no activity on social media, I ignored my email inbox, I ignored Twitter, and I mostly ignored Facebook.`}</p>
    <p>{`No new technical content, nothing really.`}</p>
    <p>{`And yet, $2529 of revenue. Either the daily vlog drove sales, thus proving my hypothesis that `}<em parentName="p">{`"Publishing anything at all, no matter what, drives sales"`}</em>{`, or I have a solid baseline and my time spent writing articles, livecoding, and making videos is mostly wasted effort.`}</p>
    <p>{`Then again, I enjoy doing it. It's my idea incubator, and it does improve sales by a few thousand dollars. `}<em parentName="p">{`shrug`}</em></p>
    <p>{`Here's how it breaks down.`}</p>
    <p><strong parentName="p">{`Total revenue:`}</strong>{` $2529`}</p>
    <p><strong parentName="p">{`Gumroad sales:`}</strong>{` $857`}</p>
    <ul>
      <li parentName="ul">{`React D3v4 preorders: $98 - fees`}</li>
      <li parentName="ul">{`ES6 Cheatsheet: $7 - fees`}</li>
      <li parentName="ul">{`React D3 ES6: $955 - fees`}</li>
    </ul>
    <p>{`*`}{`*`}{`Leanpub sales: `}{`*`}{`*`}{` $309`}</p>
    <ul>
      <li parentName="ul">{`React D3: $22`}</li>
      <li parentName="ul">{`React D3 ES6: $287`}</li>
    </ul>
    <p>{`*`}{`*`}{`React Native School: `}{`*`}{`*`}{` $1361`}</p>
    <p>{`*`}{`*`}{`Time investment: `}{`*`}{`*`}{` 68 hours`}</p>
    <p><strong parentName="p">{`Costs:`}</strong>{` $1837`}</p>
    <ul>
      <li parentName="ul">{`Editor: $500`}</li>
      <li parentName="ul">{`VA: $368`}</li>
      <li parentName="ul">{`Ads: $422`}</li>
      <li parentName="ul">{`Drip: $184`}</li>
      <li parentName="ul">{`Hosting: $10`}</li>
      <li parentName="ul">{`LiveEdu account: $10`}</li>
      <li parentName="ul">{`SumoMe: $99`}</li>
      <li parentName="ul">{`Mailchimp: $20`}</li>
      <li parentName="ul">{`Stock music: $99`}</li>
      <li parentName="ul">{`CreativeCommons music: $12`}</li>
      <li parentName="ul">{`Tech: $113`}</li>
    </ul>
    <p>{`For the life of me, I can't remember what tech purchase I made for $113. I'm sure it was necessary 🤔`}</p>
    <p>{`The biggest waste of money was the stock music purchase. It seemed like a great idea for the vlogs, but all their stuff had that awful "this is stock audio" feel to it. The `}<a parentName="p" {...{
        "href": "https://soundcloud.com/creativecommonsmusicfree"
      }}>{`Creative Commons music on Soundcloud`}</a>{` sounds a lot better.`}</p>
    <p>{`*`}{`*`}{`Net hourly rate: `}{`*`}{`*`}{` $10`}</p>
    <p>{`Based on hourly rate economics, daily vlogging looks like a waste of time after all. ’Twas a fun experiment, tho.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      